// 由 src/views/smart-workbench/index.vue 的 methods 拆分而来，请勿在此文件之外重复定义同名方法。
// 导航与交互：数字人/智能体/广场/知识库/菜单点击、路由跳转、会话定位等
// 方法体与原文件逐字节一致（仅调整文件归属）。
import { AGENT_ID_MAP } from '@/store/modules/cosmoClaw'
import { parseMenuIcon } from '@/utils/index'

export default {
  methods: {
    stopVoiceInput() {
      // 语音输入可能位于智能体聊天、固定侧栏或抽屉中的任一输入组件，
      // 会话切换前统一立即中止所有实例，避免旧会话继续占用麦克风。
      const inputs = [
        this.$refs.centerContent && this.$refs.centerContent.$refs.cosmoClawInput,
        this.$refs.centerContent && this.$refs.centerContent.$refs.selectedAgentChat,
        this.$refs.rightChatPanel && this.$refs.rightChatPanel.$refs.rightSidebarChat,
        this.$refs.rightChatPanel && this.$refs.rightChatPanel.$refs.drawerChat
      ]
      inputs.forEach((input) => {
        if (input && typeof input.cancelRecording === 'function') {
          input.cancelRecording()
        }
      })
    },
    handleDigitalHumanClick(item) {
      this.stopVoiceInput()
      this.clearDigitalPlazaTimer()
      if (item.disabled) return

      // Save current tabs to the current digital human before switching
      const currentAgentName = this.$store.state.cosmoClaw.currentAgentName
      if (currentAgentName) {
        this.$store.commit('cosmoClaw/SAVE_WORKBENCH_TABS', {
          agentName: currentAgentName,
          tabs: this.workbenchTabs,
          activeTabId: this.activeTabId
        })
      }

      this._syncRouteAgent(item.agentName || item.id)
      this.selectedCardId = item.id
      this.resetLocalThinkingState()

      // Helper to restore saved tabs for target digital human, or show workbench
      const restoreTabs = (agentName) => {
        const saved = this.$store.getters['cosmoClaw/getAgentWorkbenchTabs'](agentName)
        if (saved) {
          this.workbenchTabs = saved.tabs
          this.activeTabId = 'workbench'
        } else {
          this.workbenchTabs = [{ id: 'workbench', title: '工作台', closable: false }]
          this.activeTabId = 'workbench'
        }
      }

      // 通用数字人切换逻辑：基于 agentName 动态映射
      const agentName = item.agentName
      if (agentName) {
        const workbenchNameMap = {
          ceo_shu_zi_ren: 'CEO工作台',
          cai_wu_shu_zi_ren: 'CFO财务工作台',
          gong_ying_lian_shu_zi_ren: 'CSO供应链工作台'
        }
        const menuIdMap = {
          ceo_shu_zi_ren: 'ceo-digital',
          cai_wu_shu_zi_ren: 'cfo-digital',
          gong_ying_lian_shu_zi_ren: 'cso-digital'
        }
        this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', false)
        this.$store.commit('cosmoClaw/SET_CEO_DEMO', !!item.isDemo)
        this.$store.commit('cosmoClaw/SET_GC', !!item.isGc)
        this.$store.commit('cosmoClaw/SET_LQZ', !!item.isLqz)
        this.selectedAgent = null
        this.selectedDisplayType = ''
        this.selectedIframeSrc = ''
        // 保持用户的 clawMode 状态，不强制重置为 'assistant' (#状态保持)
        this.agentChatStarted = false
        this.$store.commit('cosmoClaw/SET_IFRAME_VISIBLE', false)
        this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
        this.$store.commit('cosmoClaw/SET_IFRAME_ITEMS', [])
        this.menuIframeItem = null
        this.selectedMenuId = menuIdMap[agentName] || agentName + '-digital'
        this.loadCurrentWorkbenchComponent({
          name: workbenchNameMap[agentName] || (item.title || '') + '工作台'
        })
        this.$store.dispatch('cosmoClaw/switchAgent', agentName)
        this.$store.dispatch('cosmoClaw/createNewSession', { agentName })
        restoreTabs(agentName)
        // 抽屉模式下默认弹出对话框
        if (this.useDrawer) {
          this.drawerVisible = true
        }
      }
    },
    handleAgentClick(item) {
      this.stopVoiceInput()
      this.clearDigitalPlazaTimer()
      if (item.disabled) return
      this._syncRouteAgent(item.agentName || item.id)
      this.selectedCardId = item.id
      this.resetLocalThinkingState()
      this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', false)
      this.selectedAgent = item.agentName
      this.selectedDisplayType = ''
      this.selectedIframeSrc = ''
      this.clawMode = 'assistant'
      this.agentChatStarted = false
      this.$store.commit('cosmoClaw/SET_IFRAME_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_IFRAME_ITEMS', [])
      this.menuIframeItem = null
      this.$store.dispatch('cosmoClaw/switchAgent', item.agentName)
      this.$store.dispatch('cosmoClaw/createNewSession', {
        agentName: item.agentName
      })
    },
    // 智能体新会话：回到初始页（createNewSession 已在子组件中 dispatch）
    handleAgentNewSession() {
      this.agentChatStarted = false
    },
    // 抽屉模式：点击"对话"按钮打开右侧抽屉
    handleSessionBtnClick(item) {
      this.stopVoiceInput()
      if (item.disabled) return
      this._syncRouteAgent(item.agentName || item.id)
      this.selectedCardId = item.id
      if (item.agentName) {
        this.selectedAgent = null
        // 保持用户的 clawMode 状态，不强制重置为 'assistant' (#状态保持)
        this.agentChatStarted = false
        this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', false)
        this.$store.commit('cosmoClaw/SET_IFRAME_VISIBLE', false)
        this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
        this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
        this.$store.commit('cosmoClaw/SET_IFRAME_ITEMS', [])
        this.menuIframeItem = null
        this.$store.dispatch('cosmoClaw/switchAgent', item.agentName)
        this.$store.dispatch('cosmoClaw/createNewSession', {
          agentName: item.agentName
        })
      }
      this.drawerVisible = true
    },
    // 抽屉模式：打开数字人广场
    _getDefaultEntry() {
      const dh = this.digitalHumanList[0]
      if (dh) return { type: 'digital', item: dh }
      const agent = this.myAgentList[0]
      if (agent) return { type: 'agent', item: agent }
      return { type: 'plaza' }
    },
    handleAgentPlazaClick() {
      this.stopVoiceInput()
      this._syncRouteAgent('agent_plaza')
      this.selectedCardId = 'agent_plaza'
      this.drawerVisible = false
      this.$store.commit('cosmoClaw/SET_IFRAME_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_IFRAME_ITEMS', [])
      this.menuIframeItem = null
      this.agentPlazaIframeUrl = ''
      this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', true)
    },
    handleAgentPlazaUse(item) {
      const url = `${process.env.VUE_APP_TIANZHI_HOST}/agent-chat/chat/assistant/${
        item.id
      }?r=0&name=${encodeURIComponent(item.name)}&style=copilot`
      // 菜单驱动的 iframe 不再写入对话 iframe 全局状态（iframeItems），由独立组件渲染
      this.agentPlazaIframeUrl = url
      this.agentPlazaIframeName = item.name
    },
    clearDigitalPlazaTimer() {
      if (this.digitalPlazaTimer) {
        clearTimeout(this.digitalPlazaTimer)
        this.digitalPlazaTimer = null
      }
    },
    handleKnowledgeBaseClick() {
      this.stopVoiceInput()
      this._syncRouteAgent('knowledge_base')
      this.selectedCardId = 'knowledge_base'
      this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_IFRAME_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_IFRAME_ITEMS', [])
      this.menuIframeItem = null
      setTimeout(() => {
        const url = process.env.VUE_APP_TIANZHI_HOST + '/developAgent/knowledge/dataset?id=' + process.env.VUE_APP_KNOWLEADGE_ID + '&etck=true'
        this.menuIframeItem = { url, name: '个人知识库' }
      }, 0)
    },
    handleMenuItemClick(menuItem) {
      if (!menuItem || !menuItem._enabled) return
      const handler = menuItem._clickHandler
      const matchItem = menuItem._matchItem
      console.log('[Menu] click:', menuItem.name, 'handler:', handler, 'matchItem:', !!matchItem)
      if (handler === 'handleDigitalPlazaClick') {
        this.handleDigitalPlazaClick()
      } else if (handler === 'handleAgentPlazaClick') {
        this.handleAgentPlazaClick()
      } else if (handler === 'handleKnowledgeBaseClick') {
        this.handleKnowledgeBaseClick()
      } else if (handler === 'handleDigitalHumanClick' && matchItem) {
        this.handleDigitalHumanClick(matchItem)
      } else if (handler === 'handleAgentClick' && matchItem) {
        this.handleAgentClick(matchItem)
      } else {
        console.warn('[Menu] unhandled click:', menuItem.name, handler, matchItem)
      }
      // 手动通知 el-menu 高亮（绕过 default-active 的内部索引过期问题）
      this.$nextTick(() => {
        const menu = this.$refs.leftSidebar && this.$refs.leftSidebar.$refs.dashboardMenu
        if (menu) {
          const idx = menuItem.permission || String(menuItem.id || menuItem.name)
          menu.activeIndex = idx
        }
      })
    },
    // 根据 selectedCardId（可能是 agent 数据库ID / permission / 菜单ID）解析唯一的 dashboard 菜单 index
    _resolveMenuIndex(cardId) {
      if (!cardId) return ''
      const id = String(cardId)
      let fallback = ''
      for (const group of this.dynamicMenuGroups || []) {
        for (const item of group.children || []) {
          const miId = item._matchItem && String(item._matchItem.id)
          const isMatch = id === miId || id === item.permission || id === String(item.id)
          if (!isMatch) continue
          const idx = item.permission || String(item.id || item.name)
          if (item._enabled) return idx // 优先启用项（区分 CEO-DH 与 CEO-DH,GC）
          if (!fallback) fallback = idx
        }
      }
      return fallback
    },
    getMenuIcon(resourceIcon) {
      return parseMenuIcon(resourceIcon)
    },
    getLocalIcon(iconName) {
      try {
        return require(`@/assets/icon/${iconName}`)
      } catch (e) {
        return ''
      }
    },
    handleDigitalPlazaClick() {
      this.stopVoiceInput()
      this.clearDigitalPlazaTimer()
      this._syncRouteAgent('digital_plaza')
      this.selectedCardId = 'digital_plaza'
      this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_IFRAME_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_IFRAME_ITEMS', [])
      this.menuIframeItem = null
      setTimeout(() => {
        if (
          !this.isSmartMode ||
          !this.isSmartEntryRoute ||
          this.selectedCardId !== 'digital_plaza'
        ) {
          return
        }
        // 数字人广场已改为 smart-engine 下的真实页面路由，不再嵌入静态 html
        const nav = this.$router.push({ name: 'SmartEngineDigitalPlaza' })
        if (nav && typeof nav.catch === 'function') {
          nav.catch(() => {})
        }
      }, 0)
    },
    // Resolve the route query to the requested digital human or agent.
    handleDashboardMenuSelect(index) {
      // el-menu 内部已处理高亮
    },
    navigateToAgent(agentId) {
      if (!agentId) return
      // 将数字 agentId 转为 agentName（如果是数字ID的话）
      const agentName = this.agentIdToName[agentId] || agentId
      // 先在数字人列表中查找
      const digitalHuman = this.digitalHumanList.find(
        (item) => item.agentName === agentName || item.id === agentName
      )
      if (digitalHuman) {
        this.handleDigitalHumanClick(digitalHuman)
        return
      }
      // 再在智能体列表中查找
      const agent = this.myAgentList.find(
        (item) => item.agentName === agentName || item.id === agentName
      )
      if (agent) {
        this.handleAgentClick(agent)
        return
      }
      // 数字人广场
      if (agentName === 'digital_plaza') {
        this.handleDigitalPlazaClick()
        return
      }
      if (agentName === 'agent_plaza') {
        this.handleAgentPlazaClick()
        return
      }
      if (agentName === 'knowledge_base') {
        this.handleKnowledgeBaseClick()
        return
      }
      // 数字人广场
      if (agentName === 'agent_plaza') {
        this.handleAgentPlazaClick()
        return
      }
      // 特殊智能体（设备管理、质量管理等）
      if (
        agentName === 'she_bei_guan_li_zhi_neng_ti' ||
        agentName === 'zhi_liang_guan_kong_zhi_neng_ti'
      ) {
        this.selectedCardId = agentName
        this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', false)
        this.selectedAgent = agentName
        this.selectedDisplayType = ''
        this.selectedIframeSrc = ''
        this.clawMode = 'assistant'
        this.agentChatStarted = false
        this.$store.commit('cosmoClaw/SET_IFRAME_VISIBLE', false)
        this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
        this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
        this.$store.commit('cosmoClaw/SET_IFRAME_ITEMS', [])
        this.menuIframeItem = null
        this.$store.dispatch('cosmoClaw/switchAgent', agentName)
        this.$store.dispatch('cosmoClaw/createNewSession', { agentName })
      }
    },
    // 同步当前选中的 agent 到 URL query 参数（使用数字 agentId）
    // 用 history.replaceState 直接改浏览器URL，不触发 Vue Router 导航
    _syncRouteAgent(nameOrId) {
      if (!nameOrId) return
      const agentId = AGENT_ID_MAP[nameOrId] || nameOrId
      if (!agentId) return
      const url = new URL(window.location.href)
      if (
        url.searchParams.get('agentId') === agentId &&
        !url.searchParams.has('sessionKey')
      ) {
        return
      }
      url.searchParams.set('agentId', agentId)
      url.searchParams.delete('sessionKey')
      window.history.replaceState(null, '', url.toString())
    },
    // 同步当前会话 key 到 URL
    _syncRouteSession(sessionKey) {
      if (!sessionKey) return
      const url = new URL(window.location.href)
      if (url.searchParams.get('sessionKey') === sessionKey) return
      url.searchParams.set('sessionKey', sessionKey)
      window.history.replaceState(null, '', url.toString())
    },
    // 根据 sessionKey 参数定位到具体会话（等会话列表加载后执行）
    _navigateToSession(sessionKey) {
      if (!sessionKey) return
      const trySwitch = (retries = 0) => {
        const session = this.filteredSessions.find(
          (s) => s.key === sessionKey || s.globalKey === sessionKey
        )
        if (session) {
          this.handleSwitchSession(session.key)
          return
        }
        // 会话还没加载出来，最多重试 10 次（约 5 秒）
        if (retries < 10) {
          setTimeout(() => trySwitch(retries + 1), 500)
        }
      }
      trySwitch()
    },
    handleClawModeChange(mode) {
      // 小屏抽屉模式下，mode切换会导致 el-drawer v-if 销毁重建 CosmoClawChat，
      // 切换前先把当前可见容器的 richHtml DOM 状态同步到 store，保证重建后内容完整
      if (this.useDrawer) {
        this.syncRichHtmlDomToStore()
      }
      this.clawMode = mode
      // 模式切换后延迟触发ECharts resize，确保容器尺寸变化后图表重新渲染
      this.$nextTick(() => {
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('echarts-need-resize'))
        }, 300)
      })
    },
    handleCardClick(card) {
      if (card.content) {
        this.$store.dispatch('cosmoClaw/sendMessage', { content: card.content })
      }
    },
    handleSmartCardAction(e) {
      const { action, value } = e.detail || {}
      if (action === 'pvmc-gross-margin-analysis' && value === 'confirm') {
        this.startPvmcAnalysis()
      }
    },
    handleSmartHtmlAction(e) {
      // 旧工作台通过 v-show 隐藏时，不处理 click 事件，避免与新工作台重复触发
      if (this.$el && !this.$el.offsetParent) return
      const target =
        e.target && e.target.closest && e.target.closest('[data-smart-action]')
      if (!target) return
      this.runSmartAction({
        action: target.getAttribute('data-smart-action'),
        plan: target.getAttribute('data-plan'),
        indicator: target.getAttribute('data-indicator')
      })
    },
    handleSmartToggleDetail(e) {
      // 旧工作台通过 v-show 隐藏时，不处理 click 事件
      if (this.$el && !this.$el.offsetParent) return
      const target =
        e.target && e.target.closest && e.target.closest('[data-toggle-detail]')
      if (!target) return
      const mid = target.getAttribute('data-toggle-detail')
      if (!mid) return
      if (window.csoV2 && window.csoV2.toggleCommDetail) {
        window.csoV2.toggleCommDetail(mid)
        return
      }
      const container = target.closest(
        '.cosmo-claw-chat, #right-sidebar-chat, #drawer-chat'
      )
      if (container) {
        const el = container.querySelector('[id="' + mid + '"]')
        if (el) {
          el.style.display = el.style.display === 'none' ? 'block' : 'none'
        }
      }
    },
    handleSmartActionEvent(e) {
      // 旧工作台通过 v-show 隐藏时，不处理事件
      if (this.$el && !this.$el.offsetParent) return
      this.runSmartAction(e.detail || {})
    },
    async runSmartAction(payload = {}) {
      const action = payload.action
      if (!action) return
      if (action === 'industry-competitiveness') {
        this.triggerIndustryCompetitiveness()
        return
      }
      if (
        action !== 'chain-performance-breakdown' &&
        action !== 'chain-revenue-breakdown'
      ) {
        this.addSmartFlowHistory(this.getSmartFlowActionText(action, payload))
        this.appendSmartUserMessage(this.getSmartFlowActionText(action, payload))
      }
      this.forceScrollToBottom()
      if (action === 'quadrant-plans') {
        this.startQuadrantPlanAnalysis()
      }
      if (action === 'pvmc-analysis') {
        this.startPvmcAnalysis()
      }
      if (action === 'pvmc-summary') {
        this.showPvmcSummary()
      }
      if (action === 'apply-plan') {
        const plan = payload.plan || this.$t('workbench.planProductStructure')
        this.startPlanApplyFlow(plan)
      }
      if (action === 'apply-recommended-indicators') {
        this.applyRecommendedIndicators()
      }
      if (action === 'apply-all-indicators') {
        this.applyAllIndicators()
      }
      if (action === 'apply-single-indicator') {
        this.applySingleIndicator(payload.indicator || '毛利率')
      }
      if (action === 'create-single-indicator') {
        this.createSingleIndicator(payload.indicator || '产品结构优化率')
      }
      if (action === 'create-missing-indicators') {
        this.startMissingIndicatorAnalysis()
      }
      if (action === 'start-create-indicators') {
        this.startCreateIndicators()
      }
      if (action === 'save-method-skill') {
        this.startSkillDeposit()
      }
      if (action === 'view-pvmc-skill') {
        this.startSkillAnalysis()
      }
      if (action === 'chain-performance-breakdown') {
        await this.persistMockMessage(
          'user',
          this.getSmartFlowActionText(action, payload)
        ).catch(function () {})
        this.triggerChainPerformanceBreakdown()
      }
      if (action === 'chain-revenue-breakdown') {
        await this.persistMockMessage(
          'user',
          this.getSmartFlowActionText(action, payload)
        ).catch(function () {})
        this.triggerChainRevenueBreakdown()
      }
    },
    handleLocalDemoMessage(e) {
      const content = (e.detail?.content || '').trim()
      if (!content) return
      const normalized = content.replace(/[「」\s]/g, '')
      // 收入业绩解构等卡片：暂不渲染任何报告卡，仅写入用户气泡
      if (
        /查看卡奥斯上半年收入业绩解构|业务链群拆解|经营业绩解构|收入业绩解构/.test(
          normalized
        )
      ) {
        this.appendSmartUserMessage(content)
        return
      }
      const match = normalized.match(/^应用(.+)指标$/)
      if (match) {
        this.addSmartFlowHistory(
          this.$t('workbench.actionApplySingleIndicator', {
            indicator: match[1]
          })
        )
        this.appendSmartUserMessage(content)
        this.applySingleIndicator(match[1], content)
        return
      }
      this.exitSmartFlowToModel(content, e.detail?.files)
    }
  }
}
